// Cross-console focus bus — lets one console deep-link an entity (country, type,
// user, sana segment) to another console. The target console reads it on mount.
let _focus = null;
export function setFocus(f) { _focus = f; }
export function takeFocus(kinds) {
  if (_focus && (!kinds || kinds.indexOf(_focus.type) !== -1)) {
    const f = _focus; _focus = null; return f;
  }
  return null;
}
